/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Viewer_Faq_Q2Inputs */

const en_viewer_faq_q2 = /** @type {(inputs: Viewer_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I use PureJSON offline?`)
};

const ko_viewer_faq_q2 = /** @type {(inputs: Viewer_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSON을 오프라인에서 사용할 수 있나요?`)
};

const ja_viewer_faq_q2 = /** @type {(inputs: Viewer_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSONをオフラインで使用できますか？`)
};

/**
* | output |
* | --- |
* | "Can I use PureJSON offline?" |
*
* @param {Viewer_Faq_Q2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const viewer_faq_q2 = /** @type {((inputs?: Viewer_Faq_Q2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Viewer_Faq_Q2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_viewer_faq_q2(inputs)
	if (locale === "ko") return ko_viewer_faq_q2(inputs)
	return ja_viewer_faq_q2(inputs)
});